/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Original_Font_Family_LabelInputs */

const en_edit_event_group_original_font_family_label = /** @type {(inputs: Edit_Event_Group_Original_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original Font Family`)
};

const fr_edit_event_group_original_font_family_label = /** @type {(inputs: Edit_Event_Group_Original_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Famille de polices d'origine`)
};

const de_edit_event_group_original_font_family_label = /** @type {(inputs: Edit_Event_Group_Original_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originale Schriftfamilie`)
};

const it_edit_event_group_original_font_family_label = /** @type {(inputs: Edit_Event_Group_Original_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Famiglia di font originale`)
};

const ru_edit_event_group_original_font_family_label = /** @type {(inputs: Edit_Event_Group_Original_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оригинальное семейство шрифтов`)
};

const es_edit_event_group_original_font_family_label = /** @type {(inputs: Edit_Event_Group_Original_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Familia de fuentes original`)
};

const zh_cn2_edit_event_group_original_font_family_label = /** @type {(inputs: Edit_Event_Group_Original_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原始字体系列`)
};

const ja_edit_event_group_original_font_family_label = /** @type {(inputs: Edit_Event_Group_Original_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリジナルフォントファミリー`)
};

const hi_edit_event_group_original_font_family_label = /** @type {(inputs: Edit_Event_Group_Original_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल फ़ॉन्ट परिवार`)
};

const pt_pt2_edit_event_group_original_font_family_label = /** @type {(inputs: Edit_Event_Group_Original_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Família de fontes original`)
};

/**
* | output |
* | --- |
* | "Original Font Family" |
*
* @param {Edit_Event_Group_Original_Font_Family_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_original_font_family_label = /** @type {((inputs?: Edit_Event_Group_Original_Font_Family_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Original_Font_Family_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_original_font_family_label(inputs)
	if (locale === "de") return de_edit_event_group_original_font_family_label(inputs)
	if (locale === "it") return it_edit_event_group_original_font_family_label(inputs)
	if (locale === "ru") return ru_edit_event_group_original_font_family_label(inputs)
	if (locale === "es") return es_edit_event_group_original_font_family_label(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_original_font_family_label(inputs)
	if (locale === "ja") return ja_edit_event_group_original_font_family_label(inputs)
	if (locale === "hi") return hi_edit_event_group_original_font_family_label(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_original_font_family_label(inputs)
	return en_edit_event_group_original_font_family_label(inputs)
});